/**
 * Impersonate (Login As) Zod schemalar
 *
 * Kanonik qarorlar (AVTOFIX_TOLIQ_QOLLANMA.md > sec 16, 27):
 *   - EGASI barcha xodimlarga impersonate qila oladi
 *   - ADMIN faqat o'zi yaratgan xodimlarga (createdById = admin.id)
 *   - XODIM hech kimga impersonate qila olmaydi
 *   - Har bir impersonation server-side audit log'ga yoziladi
 *   - Impersonation token'i originalUserId ni saqlaydi (qaytarish uchun)
 *
 * Endpointlar:
 *   POST /auth/impersonate       — loginAs: {userId}
 *   POST /auth/impersonate/stop  — originalga qaytish
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Impersonate (loginAs) ────────────────────────────────────────
export const impersonateSchema = z.object({
    userId: uuidSchema,
});
// ─── Stop impersonation ───────────────────────────────────────────
// Body kerak emas — JWT payload originalUserId ni ichiga oladi
export const stopImpersonationSchema = z.object({}).strict();
//# sourceMappingURL=impersonate.schema.js.map